var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var drivingMarketOptionsStream = function (data, streaming) {
    var _a, _b;
    var newData = {
        call: [],
        put: [],
        latestUpdatedTime: data === null || data === void 0 ? void 0 : data.latestUpdatedTime,
    };
    newData.latestUpdatedTime = (streaming === null || streaming === void 0 ? void 0 : streaming.updatedTime)
        ? streaming === null || streaming === void 0 ? void 0 : streaming.updatedTime
        : data === null || data === void 0 ? void 0 : data.latestUpdatedTime;
    newData.call = (_a = data === null || data === void 0 ? void 0 : data.call) === null || _a === void 0 ? void 0 : _a.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { change: streaming === null || streaming === void 0 ? void 0 : streaming.changePrice, changePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.changePercentage, latestTradingPrice: streaming === null || streaming === void 0 ? void 0 : streaming.curPrice, openInterestChange: streaming === null || streaming === void 0 ? void 0 : streaming.oiChange, oiChangePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.oiChangePercentage, 
                // volume: streaming?.volume,
                // volumeChange: streaming?.volumeChange,
                // volumeChangePercentage: streaming?.volumeChangePercentage,
                openInterest: streaming === null || streaming === void 0 ? void 0 : streaming.openInterest });
        }
        return x;
    });
    newData.put = (_b = data === null || data === void 0 ? void 0 : data.put) === null || _b === void 0 ? void 0 : _b.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { change: streaming === null || streaming === void 0 ? void 0 : streaming.changePrice, changePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.changePercentage, latestTradingPrice: streaming === null || streaming === void 0 ? void 0 : streaming.curPrice, openInterestChange: streaming === null || streaming === void 0 ? void 0 : streaming.oiChange, oiChangePercentage: streaming === null || streaming === void 0 ? void 0 : streaming.oiChangePercentage, 
                // volume: streaming?.volume,
                // volumeChange: streaming?.volumeChange,
                // volumeChangePercentage: streaming?.volumeChangePercentage,
                openInterest: streaming === null || streaming === void 0 ? void 0 : streaming.openInterest });
        }
        return x;
    });
    return newData;
};
export var optionChainStreamingUpdate = function (data, stream) {
    if (data.future.symbol === stream.symbol) {
        return __assign(__assign({}, data), { lut: stream.updatedTime, future: __assign(__assign({}, data.future), { latestTradingPrice: stream.curPrice, change: stream.changePrice, changePercentage: stream.changePercentage, status: stream.marketStatus }) });
    }
    else if (data.spot.symbol === stream.symbol) {
        return __assign(__assign({}, data), { lut: stream.updatedTime, spot: __assign(__assign({}, data.spot), { latestTradingPrice: stream.curPrice, change: stream.changePrice, changePercentage: stream.changePercentage }) });
    }
    else {
        return __assign(__assign({}, data), { lut: stream.updatedTime, optionChain: data.optionChain.map(function (z) {
                if (z.call.symbol === stream.symbol) {
                    z.call = __assign(__assign({}, z.call), { change: stream.changePrice, changePercentage: stream.changePercentage, latestTradingPrice: stream.curPrice, 
                        // openInterest: summarizeWithType(
                        //   stream?.openInterest,
                        //   summarizeType.LAKHS,
                        //   false
                        // ).toString(),
                        // openInterestChange: summarizeWithType(
                        //   stream?.oiChange,
                        //   summarizeType.LAKHS,
                        //   false
                        // ).toString(),
                        volume: stream === null || stream === void 0 ? void 0 : stream.volume });
                }
                if (z.put.symbol === stream.symbol) {
                    z.put = __assign(__assign({}, z.put), { change: stream.changePrice, changePercentage: stream.changePercentage, latestTradingPrice: stream.curPrice });
                }
                return z;
            }) });
    }
};
